export enum FollowQueryKeys {
  FOLLOWED_TEAMS = 'followed-teams',
  SUGGESTED_TEAMS = 'suggested-teams-to-follow',
}
